import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { ReactComponent as RightHandle } from 'new/components/icons/handleRight.svg';
import classes from '../../FlowNodes.module.scss';

interface StandardHandleProps {
  /** Handle ID for React Flow */
  id?: string;
  /** Whether the handle is connectable */
  isConnectable?: boolean;
  /** Layout direction for positioning */
  layoutDirection?: 'LR' | 'TB';
}

/**
 * Standard handle for API server nodes with existing connections.
 * Displays a simple right-side handle icon.
 */
export const StandardHandle: React.FC<StandardHandleProps> = ({
  id = 'right',
  isConnectable = false,
  layoutDirection = 'LR',
}) => {
  const position = layoutDirection === 'TB' ? Position.Bottom : Position.Right;

  return (
    <Handle
      type="source"
      position={position}
      id={id}
      className={`${classes.handle_custom_svg} ${classes.handleStandardPosition}`}
      isConnectable={isConnectable}
    >
      <RightHandle
        style={{
          fill: 'var(--color-primary-600)',
          width: '16px',
          height: '16px',
        }}
      />
    </Handle>
  );
};
